import {Injectable} from "@angular/core";
import {ApiService} from "../../../../services/api.service";
import {SweetalertService} from "../../../../services/sweetalert.service";
import {Subject} from "rxjs";

@Injectable()
export class PoolManageService {
  private observer = new Subject();
  public pool = this.observer.asObservable();

  constructor(private apiService: ApiService, private sweetalertService: SweetalertService) {
  }

  public updatePool(id) {
    this.apiService.getPool(id).subscribe((response: any) => {
      this.observer.next(response.data);
    }, error => {
      this.sweetalertService.connectionError();
    })
  }
}
